export const DIALER_INCOMING_CALL_TYPE = "incoming_call";
export const DIALER_OUTGOING_CALL_TYPE = "outgoing_call";

export const DIALER_VIEW_MODE_EXPANDED = "expanded";
export const DIALER_VIEW_MODE_COLLAPSED = "collapsed";

export const DIALER_CALL_STATE_QUEUED = "Queued";
export const DIALER_CALL_STATE_ON_HOLD = "On Hold";
export const DIALER_CALL_STATE_PICKED_UP = "Picked Up";
